import { Utils } from "../../../../../services/utils.service";
import { DataCollection } from "../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { TransportData } from "../../../../infrastructure/transportdata";


export class FinancialYearMasterFetchRequest {
    public static readonly FetchRequestType: string = "financial_year_master_fetch_request";
financial_year_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, FinancialYearMasterFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

